import { GroupOutlinedIcon, HistoryIcon, ManageAccountsOutlinedIcon } from '@shared/components';

export const iconMapper: Record<string, JSX.Element> = {
  USERS: <GroupOutlinedIcon />,
  ROLES: <ManageAccountsOutlinedIcon />,
  LOGS: <HistoryIcon />,
};
